import AppLayout from "components/Layout/AppLayout";
import React, { useEffect, useState } from "react";
import DashboardSaveSearches from "./components/DashboardSaveSearches";
import WatchlistProperties from "./components/WatchlistProperties";
import HiddenCostInfoBanner from "./components/HiddenCostInfoBanner";
import HousePriceCalculator from "./components/HousePriceCalculator";
import DoubtProperties from "./components/DoubtProperties";
import HowDoesItWork from "./components/HowDoesItWork";
import WeeklyRecap from "./components/WeeklyRecap";
import PropertiesWithTopGrossYield from "./components/PropertiesWithTopGrossYield";
import BestPriceM2Properties from "./components/BestPriceM2Properties";
import RecentEditedLists from "./components/RecentEditedLists";
import NotSubscribed from "components/Subscribe/NotSubscribed";
import CustomListDialog from "components/Dialog/CustomListDialog";
import useSubscriptionLogic from "hooks/useSubscriptionLogic";
import PaginatedPropertiesPopup from "./components/PaginatedPropertiesPopup";
import { useLocation } from "react-router";
import useSubscription from "hooks/useSubscription";

const Dashboard = () => {
  const {
    user,
    authLoading,
    showNotSubscribed,
    isOpenListDialog,
    setIsOpenListDialog,
    handleOrganiseListAdd,
  } = useSubscriptionLogic();
  const { subscriptionStatus } = useSubscription();
  const isPremium = subscriptionStatus.hasPremium;
  const location = useLocation();

  // Scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <AppLayout>
      <div
        className={` bg-[#F5F5F5] h-auto min-h-[calc(100vh-88px)] py-[29px] md:py-[41px] px-5 md:px-[30px] lg:px-[48px] pb-[100px] md:pb-5`}
      >
        {user && isPremium ? (
          // showNotSubscribed ? (
          //   <NotSubscribed
          //     isDashboard
          //     dsetIsOpenListDialog={setIsOpenListDialog}
          //   />
          // ) : (
          <>
            <div className="max-w-[1576px] mx-auto flex items-start flex-col 2xl:flex-row 2xl:space-x-10 space-y-6 2xl:space-y-0">
              <div className="w-full 2xl:w-[calc(72%-40px)]">
                <div className="space-y-5">
                  <DashboardSaveSearches />
                  <WatchlistProperties />
                  <HiddenCostInfoBanner />
                  <HousePriceCalculator />
                  <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-6 lg:space-y-0">
                    <DoubtProperties />
                    <HowDoesItWork />
                  </div>
                </div>
              </div>

              <div className="w-full 2xl:w-[28%] flex flex-col space-y-[18px]">
                <WeeklyRecap />
                <PropertiesWithTopGrossYield />
                <div className="grid grid-cols-1 items-start gap-[18px] w-full md:grid-cols-2 2xl:grid-cols-1">
                  <BestPriceM2Properties />
                  <RecentEditedLists />
                </div>
              </div>
            </div>
          </>
        ) : (
          // )
          !authLoading && (
            <NotSubscribed
              isDashboard
              setIsOpenListDialog={setIsOpenListDialog}
            />
          )
        )}
      </div>
      <CustomListDialog
        isOpen={isOpenListDialog}
        onClose={() => setIsOpenListDialog(false)}
        onAdd={handleOrganiseListAdd}
      />
    </AppLayout>
  );
};

export default Dashboard;
